export default __webpack_public_path__ + "static/media/0x9cd6746665d9557e1b9a775819625711d0693439.431d2d86.webp";